import { render, staticRenderFns } from "./WhyConcerned.vue?vue&type=template&id=05576f0a&"
import script from "./WhyConcerned.vue?vue&type=script&lang=js&"
export * from "./WhyConcerned.vue?vue&type=script&lang=js&"
import style0 from "./WhyConcerned.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports